import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import DialogOTP from '../components/Complements/DialogOTP';
import UserPanelInfo from '../components/Complements/UserPanelInfo';
import ElectronicRechargesFormReduxForm from '../components/ElectronicRecharges/ElectronicRechargesForm'
import StandardDialog from '../components/Complements/StandardDialog';
import FormSaveAliasReferenceDialogReduxForm from "../components/Taxes/FormSaveAliasReferenceDialog"
import MessageInfo from '../components/Complements/MessageInfo';
import ElectronicRechargesFormEditFavoriteReduxForm from "../components/ElectronicRecharges/ElectronicRechargesFormEditFavorite"
import { Grid, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, IconButton, Typography } from '@material-ui/core';
import { validateIp } from '../functions/store';
import DeleteIcon from '@material-ui/icons/Delete';
import { osName, osVersion, isMobile } from 'react-device-detect';
import { isEmpty } from '../functions/arrays';
import ElectronicRechargesInfoPanel from "../components/Taxes/ElectronicRechargesInfoPanel"
import GradeIcon from '@material-ui/icons/Grade';
import EditIcon from '@material-ui/icons/Edit';
import Voucher from '../components/Transfers/Voucher';
import StandardList from "../components/Complements/StandardList"
import { feathersCreateData, feathersFindGET } from "../services"
import {  createProcessMeterCode } from './../actions/metersCore'
import { sendEmailWithVoucher } from "./../actions/sendEmailWithVoucher";
import { changeStatusUser } from './../actions/codes'
import { getAgreementsSwitchServices } from '../actions/agreementsSwitchServices'
import { getBalanceUser } from "./../actions/balances";
import { encrypt, decrypt, sendMobile } from '../functions/mobile';
import { history } from '../helpers/history';
import { urlVoucher } from '../services/urls';
import moment from 'moment'
import { handleDownloadMovil, handleDownloadWeb } from '../functions/handle-download';

const ElectronicRechargesContainer = props => {

    const { user, auth, balances, agreementsSwitchServices, allAgreementsSwicthServices, otherServices, parameters, handleOpenSnack, getDeviceData, devices, updateIpDevice, createProcessMeterCode } = props

    const [ accountSelected, setAccountSelected ] = useState(balances[0])
    const [ dataFavoritesReference, setDataFavoritesReference ] = useState([])
    const [ agreementRateSelected, setAgreementRateSelected ] = useState({
        Secuencial : 0,
        Nombre : "",
        Comision : 0
    })
    //const [ dataAgreementRate, setDataAgreementRate ] = useState([])
    const [ showDialogAccounts, setShowDialogAccounts ] = useState(false)
    const [ agreementsSelected, setAgreementsSelected ] = useState({
        AgreementForm : [],
        category : "",
        hasIndividualRate : 1,
        hasBilling : 1,
        name : "",
        rate : "0",
        uuid : "",
        identity : "",
        nameIdentity : ""
    })
    const [ loading, setLoading ] = useState(false)
    const [ showVoucher, setShowVoucher ] = useState(false)
    const [ dataVoucher, setDataVoucher ] = useState({})
    const [ isFavorites, setIsFavorites ] = useState(false)
    const [ isSelectedFavorite, setIsSelectedFavorite ] = useState(false)
    const [ isSelectedOptionMenu, setIsSelectedOptionMenu ] = useState(true)
    const [ dialogTitle, setDialogTitle ] = useState('')
    const [ dialogContent, setDialogContent ] = useState(<div></div>)
    const [ openDialog, setOpenDialog ] = useState(false)
    const [authorizedTransactions, setAuthorizedTransactions] = useState(false)

    //Dialogo para guardar el alias en favoritos
    const [ openDialogAddFavorites, setOpenDialogAddFavorites ] = useState(false)

    const [ dataElectronicRecharges, setDataElectronicRecharges ] = useState({
        cellphone : "",
        amount : "",
        valueWithCommission : "",
        concept : "",
        alias : ""
    })
    const [ showDetailPayment, setShowDetailPayment ] = useState(false)
    const [ OTP, setOTP ] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    })
    //Editar Referencia Favorita
    const [ initialValuesFormEditFavorites, setInitialValuesFormEditFavorites ] = useState({
        alias : "",
        reference : "",
        agreement : {
            AgreementForm : [],
            category : "",
            hasIndividualRate : 1,
            name : "",
            rate : "0",
            uuid : "",
            identity : "",
            nameIdentity : ""
        },
        id : 0,
    })

    const [ dataList ] = useState([
        {id: '1', primary: 'Seleccione una referencia de favoritos', secondary: '', icon: 'phone' },
        {id: '2', primary: 'Nueva referencia a recargar', secondary: '', icon: 'add_ic_call'}
    ])

    const [ listDetail, setListDetail ] = useState([
        {   
            id: '1', 
            title: "", 
            data: "",             
            icon: 'school', 
            pstyle: {   
                        color: 'rgb(0, 0, 1)', 
                        fontWeight: 'bold', 
                        fontSize: '0.875rem'
                    },
            sstyle: { 
                        color: 'rgb(0, 0, 1)', 
                        fontSize: '0.8rem'
                    } 
        },
        { 
            id: '2', 
            title: "", 
            data: "",               
            icon: 'account_circle', 
            pstyle: { 
                        color: 'rgb(0, 0, 1)', 
                        fontWeight: 'bold', 
                        fontSize: '0.875rem'
                    },
            sstyle: { 
                        color: 'rgb(0, 0, 1)', 
                        fontSize: '0.8rem'
                    } 
        },
        { 
            id: '3', 
            title: "", 
            data: "",               
            icon: 'account_circle', 
            pstyle: { 
                        color: 'rgb(0, 0, 1)', 
                        fontWeight: 'bold', 
                        fontSize: '0.875rem'
                    },
            sstyle: { 
                        color: 'rgb(0, 0, 1)', 
                        fontSize: '0.8rem'
                    } 
        },
        { 
            id: '4', 
            title: "", 
            data: "",               
            icon: 'account_circle', 
            pstyle: { 
                        color: 'rgb(0, 0, 1)', 
                        fontWeight: 'bold', 
                        fontSize: '0.875rem'
                    },
            sstyle: { 
                        color: 'rgb(0, 0, 1)', 
                        fontSize: '0.8rem'
                    } 
        },
        {
            id: '5', 
            title: 'Valor a pagar', 
            data: "",            
            icon: 'monetization_on', 
            pstyle: { 
                        color: 'rgb(0, 160, 175)', 
                        fontWeight: 'bold', 
                        fontSize: '1.05rem'
                    },
            sstyle: { 
                        color: 'rgb(0, 160, 175)', 
                        fontWeight: 'bold', 
                        fontSize: '1rem'
                    } 
        },
    ])

    // const  AuthorizedTransactions = true

    const mount = () => {
        const unmount = () => {
            handleGetReferenceFavorites()
            if(otherServices.length === 0){
                handleOpenSnack("No se ha encontrado el valor de convenios", "error")
                history.push('/')
            }

            if(allAgreementsSwicthServices.length === 0){
                handleGetAllAgreementsSwicthServices()
            }
            setAuthorizedTransactions(Boolean(props.auth.companies.authorizeTransactions))
        }
        return unmount()
    }

    useEffect(mount, [])

    //VOUCHER

    const handleDownloadVoucher = () => {
        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataVoucher.DocumentoTransaccion, name_voucher: dataVoucher.name_voucher})().then(res => {
            if (res.error) {
                handleOpenSnack(res.message, 'error')
            } else {
                if (localStorage.caja_app !== undefined) {
                    // let send = {
                    //     type: 'action',
                    //     action: 'download_voucher',
                    //     data: urlVoucher+res.voucher+".pdf",
                    //     messageSend: 'Comprobante'
                    // }
                    // sendMobile(JSON.stringify(send))
                    handleDownloadMovil(urlVoucher, res.voucher)
                    
                } else {
                    // window.open(urlCertificates+nameFile+".pdf", '_blank');
                    handleDownloadWeb(urlVoucher, res.voucher)
                }
            }
        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
       
    }

    // PETICIONES AL SERVIDOR

    const handleGetAllAgreementsSwicthServices = async() => {

        setLoading(true)

        try {
            
            await props.getAgreementsSwitchServices().then( res => {
                setLoading(false)
            }).catch( error => {
                setLoading(false)
            })

        } catch (error) {
            //console.log(error)
            setLoading(false)
        }
    }

    const handleGetReferenceFavorites = async() => {

        setLoading(true)

        try {

            const data_favorite_reference = await feathersFindGET("favorite-reference-company", {
                categoryAgreement : "RECARGAS",
                state : 1
            })()
            
            //console.log(data_favorite_reference)
            
            setDataFavoritesReference(data_favorite_reference)

            setLoading(false)

        } catch (error) {
            
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al obtener los números de celular favoritos.", "error")

        }
    }

    const handleUpdatedBalances = async() => {
        await props.getBalanceUser({NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true}).then( res => {
            
            const { data } = res.payload;
            const getdataaccountselected = data.filter(item => {
                return (item.Secuencial === accountSelected.Secuencial) ? true : false;
                
            })

            setAccountSelected(getdataaccountselected[0])

        })
        .catch(err=> {
            //console.log(' error al obtener balances ', err)
        })
    }

    const handleChangeAgreement = (objectAgreement) => {

        try {
            
            setLoading(true)

            const { nameIdentity } = objectAgreement;

            const response_filter_agreement_rate = otherServices.filter( (item) => item.Nombre === nameIdentity);

            //console.log(response_filter_agreement_rate)

            if(response_filter_agreement_rate.length > 0){
                setAgreementsSelected(objectAgreement)
                setAgreementRateSelected(response_filter_agreement_rate[0])
            }else{
                handleOpenSnack("No se ha encontrado el convenio para realizar la recarga.", "info");
                setAgreementsSelected({
                    AgreementForm : [],
                    category : "",
                    hasIndividualRate : 1,
                    name : "",
                    rate : "0",
                    uuid : "",
                    identity : "",
                    nameIdentity : ""
                })
            }

            setLoading(false)

        } catch (error) {
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al seleccionar el convenio", "error");
        }
    }

    const handleAccountChange = () => {
        setShowDialogAccounts(!showDialogAccounts)
    }

    const handleChangeInputOtp = (valueinput) => {
        if(valueinput.target.value.toString().length === 4){
            handleOTPCompare({data : valueinput.target.value.toString()});
        }
    }

    const handleOTPCompare = async({data}) => {

        try {
            
            setLoading(true)

            // const { type } = OTP

            const {ip, device, mac} = devices

            const sendData = encrypt(JSON.stringify({
                ip,
                mac,
                device,
                type : 27,
                inputOtp : data
            }))

            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type : typeMessage, viewDialogOtp } = responseValidateCode;

            if(error === false){
                //console.log("codigo correcto")

                const sendData = encrypt(JSON.stringify({
                    access : "ELECTRONIC_RECHARGES",
                    channel : "WEB",
                    body : {
                        agreement : agreementsSelected.uuid,
                        reference : dataElectronicRecharges.cellphone,
                        amount : dataElectronicRecharges.amount,
                        rate : agreementRateSelected.Comision,
                        valueWithCommission : dataElectronicRecharges.valueWithCommission,
                        concept : dataElectronicRecharges.concept,
                        billingData : {
                            identification : user.Identificacion,
                            name : user.Nombres + " " + user.Apellidos,
                            cellphone : user.Telefono,
                            email : user.CorreoElectronico,
                            address : user.Direccion
                        },
                        otp : data,
                        NumeroCliente : user.NumeroCliente,
                        SecuencialOtherServices : agreementRateSelected.Secuencial,
                        SecuencialCuenta : accountSelected.Secuencial,
                        NumeroCuentaOrigen : accountSelected.Codigo,
                        NombreInstitucion: agreementsSelected.name
                    },
                    device : {
                        ip,
                        mac,
                        device
                    },
                    dataDevice:{
                        ip,
                        mac,
                        device
                    },
                    NumeroCuentaOrigen : accountSelected.Codigo,
                    Valor: dataElectronicRecharges.valueWithCommission,
                    Detalle: dataElectronicRecharges.concept,
                    NumeroCuentaDestino : dataElectronicRecharges.cellphone,
                }))

                if (authorizedTransactions) {
                    const response_payment = await feathersCreateData("transactions-control", {
                        service: 'TRANSFERS',
                        func: 'CREATE_AUTHORIZED_ELECTRONIC_RECHARGE',
                        data: sendData
                            
                        })()
                    console.log(response_payment)
    
                    const { error, 
                        // response, 
                        errors } = response_payment;
    
                    if(error === false) {
                
                        setOTP({
                            ...OTP,
                            openOtp: false
                        })
                        
                        handleOpenSnack('Se ha guardado exitosamente el pago.', 'success')
                        setShowVoucher(false)
                        history.push('/')
    
                    }else{
    
                        setOTP({
                            ...OTP,
                            openOtp: false
                        })
                        handleOpenSnack((errors.length > 0) ? errors[0].message : "Ha ocurrido un error al realizar el pago.", "error")
                    }
                } else {
                    const response_electronic_recharges = await feathersCreateData("switch-services", {
                        sendData
                    })()
    
                    const { responseData } = response_electronic_recharges

                    const response_electronic_recharges_decrypt = JSON.parse(decrypt(responseData))
        
                    const { error, response, errors } = response_electronic_recharges_decrypt;
    
                    if(error === false) {
    
                        setOTP({
                            ...OTP,
                            openOtp: false
                        })
                        handleUpdatedBalances()
                        setDataVoucher(response)
                        setShowVoucher(true)
                        handleOpenSnack('Se ha realizado exitosamente la recarga.', 'success')
    
                    }else{
    
                        setOTP({
                            ...OTP,
                            openOtp: false
                        })
                        handleOpenSnack((errors.length > 0) ? errors[0].message : "Ha ocurrido un error al realizar el pago.", "error")
                    }
    
                    setLoading(false)
                }
            }else{
                if(viewDialogOtp === false){
                    setOTP({...OTP, openOtp: false})
                }
                setLoading(false)
                handleOpenSnack(message, typeMessage);
            }
        } catch (error) {

            //console.log(error)
            setLoading(false)
            setOTP({
                ...OTP,
                openOtp: false
            })

            switch (OTP.type) {
                case "PAYMENT_ELECTRONIC_RECHARGES":
                        handleOpenSnack("Ha ocurrido un error al realizar el pago.", "error")
                    break;
                case "SAVE_FAVORITES_REFERENCE":
                        handleOpenSnack("Ha ocurrido un error al realizar el pago.", "error")
                    break;
                default:
                        handleOpenSnack("Ha ocurrido un error.", "error")
                    break;
            }
            //handleOpenSnack("Ha ocurrido un error al realizar el pago.", "error")
        }
    }

    const handleSubmit = (values) => {
        //console.log(values)
        //console.log(agreementsSelected)

        const { cellphone, amount } = values
        

        if(agreementsSelected.uuid.length > 0){

            if(parseFloat(amount) > 0){

                if(cellphone){

                    const response_filter_validation_repeat_favorites = dataFavoritesReference.filter((item) => ((item.reference === cellphone) && (item.agreement === agreementsSelected.identity)))
    
                    if(response_filter_validation_repeat_favorites.length > 0){
                        setIsFavorites(true)
                    }else{
                        setIsFavorites(false)
                    }

                }else{
                    setIsFavorites(true)
                }

                setListDetail(
                    [
                        {   
                            id: '1', 
                            title: "Convenio", 
                            data: agreementsSelected.name,             
                            icon: 'business', 
                            pstyle: {   
                                        color: 'rgb(0, 0, 1)', 
                                        fontWeight: 'bold', 
                                        fontSize: '0.875rem'
                                    },
                            sstyle: { 
                                        color: 'rgb(0, 0, 1)', 
                                        fontSize: '0.8rem'
                                    } 
                        },
                        { 
                            id: '2', 
                            title: "Referencia", 
                            data: (cellphone) ? cellphone : dataElectronicRecharges.cellphone,               
                            icon: 'smartphone', 
                            pstyle: { 
                                        color: 'rgb(0, 0, 1)', 
                                        fontWeight: 'bold', 
                                        fontSize: '0.875rem'
                                    },
                            sstyle: { 
                                        color: 'rgb(0, 0, 1)', 
                                        fontSize: '0.8rem'
                                    } 
                        },
                        { 
                            id: '3', 
                            title: "Valor recarga", 
                            data: parseFloat(amount).toFixed(2),               
                            icon: 'attach_money', 
                            pstyle: { 
                                        color: 'rgb(0, 0, 1)', 
                                        fontWeight: 'bold', 
                                        fontSize: '0.875rem'
                                    },
                            sstyle: { 
                                        color: 'rgb(0, 0, 1)', 
                                        fontSize: '0.8rem'
                                    } 
                        },
                        { 
                            id: '4', 
                            title: "Comisión", 
                            data: parseFloat(agreementRateSelected.Comision).toFixed(2),               
                            icon: 'attach_money', 
                            pstyle: { 
                                        color: 'rgb(0, 0, 1)', 
                                        fontWeight: 'bold', 
                                        fontSize: '0.875rem'
                                    },
                            sstyle: { 
                                        color: 'rgb(0, 0, 1)', 
                                        fontSize: '0.8rem'
                                    } 
                        },
                        {
                            id: '5', 
                            title: 'Valor a Pagar', 
                            data: parseFloat( parseFloat(amount) + parseFloat(agreementRateSelected.Comision)).toFixed(2),            
                            icon: 'monetization_on', 
                            pstyle: { 
                                        color: 'rgb(0, 160, 175)', 
                                        fontWeight: 'bold', 
                                        fontSize: '1.05rem'
                                    },
                            sstyle: { 
                                        color: 'rgb(0, 160, 175)', 
                                        fontWeight: 'bold', 
                                        fontSize: '1rem'
                                    } 
                        },
                    ]
                )
    
                let auxDataElectronicRecharges = dataElectronicRecharges;
                
                if(cellphone) { auxDataElectronicRecharges.cellphone = cellphone }
                auxDataElectronicRecharges.amount = parseInt(amount);
                auxDataElectronicRecharges.valueWithCommission = parseFloat( parseFloat(amount) + parseFloat(agreementRateSelected.Comision)).toFixed(2)
    
                setDataElectronicRecharges(auxDataElectronicRecharges)

                setShowDetailPayment(true)

            }else{

                handleOpenSnack("El monto debe ser mayor a 0.", "info")
            }

        }else{

            handleOpenSnack("Debe seleccionar un convenio.", "info")
        }

    }

    const handleSubmitPayment = async(values) => {
        //console.log(values)

        try {
            setLoading(true)

            const resultFilterValueMinBalance = parameters.filter( (param) => param.name === "MINIMUM_BALANCE")
            const valueMinBalance = (resultFilterValueMinBalance.length > 0) ? resultFilterValueMinBalance[0].value : "2"

            const { description } = values

            setDataElectronicRecharges({
                ...dataElectronicRecharges,
                concept : description.toUpperCase()
            })

            //console.log(accountSelected.SaldoCuenta)

            if(parseFloat(dataElectronicRecharges.valueWithCommission) > parseFloat(accountSelected.SaldoCuenta)){

                setLoading(false)
                handleOpenSnack('El valor excede el saldo disponible.', 'error')

            }else{

                if((parseFloat(accountSelected.SaldoCuenta) - parseFloat(dataElectronicRecharges.valueWithCommission)) < parseFloat(valueMinBalance)){

                    setLoading(false)
                    handleOpenSnack('El valor del saldo mínimo no debe ser menor a $ '+valueMinBalance, 'error')

                }else{
                    
                    handleGenerateOtp(27, "PAYMENT_ELECTRONIC_RECHARGES")

                }

            }
            
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')

        }

    }

    const onCancelAction = () => {
        setIsSelectedOptionMenu(true)
    }

    const onChangeAgremeement = () => {
        setShowDetailPayment(false)
    }

    const handleGenerateOtp = async (type, action) => {

        setLoading(true)
        
        try {

            const { ip } = devices
            
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)

            let deviceData =`${osName} ${osVersion}`
            let mac = 'NAVEGADOR'

            if (!isEmpty(devices)) {
                const { device, ip: ipDevice, mac: macDevice } = devices
                deviceData = device;
                ipSend = ipDevice;
                mac = macDevice;
            }

            const sendData = encrypt(JSON.stringify({
                emited: 'NAVCREATECODE', type, deviceData, ip: ipSend, mac
            }))
            
            createProcessMeterCode({ sendData })
                .then(({payload}) => {
                    //const { result, data } = payload
                    setOTP({
                        ...OTP,
                        //id: data.sequence,
                        //code: result,
                        type: action,
                        openOtp: true
                    })
                    setLoading(false)
            }).catch(err => {
                //console.log(err)
                setLoading(false)
                handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')
            })

        } catch (error) {
            
            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')

        }
    }

    //AGREGAR A FAVORITOS

    const renderListReferenceFavorites = () => {

        return <List>
                    {
                        (dataFavoritesReference.length > 0) ? dataFavoritesReference.map( item => {
                        return <div key = {item.id}>
                                    <ListItem button onClick = { () => handleSelectedReferenceFavorites(item) }>
                                        <ListItemAvatar>
                                            <GradeIcon />
                                        </ListItemAvatar>
                                        <ListItemText primary={ item.name } secondary={renderDetailReferenceFavorites(item)} />
                                        <ListItemSecondaryAction>
                                            <IconButton edge="end" aria-label="delete" onClick = {() => editReferenceFavorites(item) } >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton edge="end" aria-label="delete" onClick = {() => deleteReferenceFavorites(item) } >
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                            </div>
                        }) : <ListItem >
                                <ListItemText primary={ "No se han encontrado referencias favoritas." } />
                            </ListItem>
                    }
                </List>
    }

    const renderDetailReferenceFavorites = (item) => {

        return  <Typography >
                    <b>{ `Referencia: `}</b>{ `${item.reference} `}
                    <br />
                    <b>{ `Convenio: `}</b>{ `${item.institution} `}
                </Typography>
    }

    const deleteReferenceFavorites = async(row) => {

        try {
            
            setLoading(true)

            const sendData = encrypt(JSON.stringify({
                action : "UPDATE",
                dataFavoriteReference : {
                    id : row.id,
                    state : 0
                }
            }))

            await feathersCreateData("procces-favorite-reference", { sendData })()

            let aux_data_favorites_reference = dataFavoritesReference;

            let index = aux_data_favorites_reference.findIndex( (item) => item.id === row.id)

            aux_data_favorites_reference.splice(index, 1)

            //console.log(aux_data_favorites_reference)

            setDataFavoritesReference(aux_data_favorites_reference)

            setDialogContent(renderListReferenceFavorites())

            handleOpenSnack("Se ha eliminado correctamente.", "success")

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al eliminar un favorito.", "error")

        }
    }

    const editReferenceFavorites = (row) => {

        try {
            //console.log(row)

            setLoading(true)

            const { reference, agreement, name } = row

            const response_filter_agreement = agreementsSwitchServices.filter( (item) => item.identity === agreement)

            //console.log(response_filter_agreement)

            if(response_filter_agreement.length > 0){

                let auxInitialValuesFormEditFavorites = initialValuesFormEditFavorites;

                auxInitialValuesFormEditFavorites.alias = name;
                auxInitialValuesFormEditFavorites.reference = reference
                auxInitialValuesFormEditFavorites.id = row.id
                auxInitialValuesFormEditFavorites.agreement = response_filter_agreement[0]

                setInitialValuesFormEditFavorites(auxInitialValuesFormEditFavorites);

                //console.log(initialValuesFormEditFavorites)

                setDialogTitle("Editar Referencia Favorita")
                setDialogContent(renderFormEditFavorites())

            }else{
                handleOpenSnack("No se ha encontrado el convenio de la referencia favorita seleccionada.", "info")
            }

            setLoading(false)

        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al cargar la información de la referencia favorita.", "error")
        }
        
    }

    const handleChangeAgreementEditFavorite = async(agreement) => {
        //console.log(agreement)

        let aux = initialValuesFormEditFavorites;

        aux.agreement = agreement

        await setInitialValuesFormEditFavorites(aux)

        //console.log(initialValuesFormEditFavorites)
    }

    const renderFormEditFavorites = () => {
        return <div><ElectronicRechargesFormEditFavoriteReduxForm
                    onSubmit = { handleUpdatedFavorites }
                    agreements = { agreementsSwitchServices }
                    handleChangeAgreementEditFavorite = { handleChangeAgreementEditFavorite }
                    onCancelAction = { handleCancelFormEditFavorites }
                    initialValues = { initialValuesFormEditFavorites }
                    titleLabelReference = { "Referencia" }
                    titleLabelAgreement = { "Seleccione un convenio" }
                /></div>
    }

    const handleUpdatedFavorites = async(valuesFormEditFavorites) => {
        //console.log(valuesFormEditFavorites)

        setLoading(true)

        try {

            let flag_validation_repeat_favorite = false
            
            const { alias, reference } = valuesFormEditFavorites

            const { agreement } = initialValuesFormEditFavorites

            const response_filter_agreement = agreementsSwitchServices.filter( (row) => row.name === agreement.name)

            const response_filter_data_reference_favorite = dataFavoritesReference.filter( (item) => item.id === initialValuesFormEditFavorites.id)

            if(response_filter_agreement.length > 0){

                if(alias.toUpperCase() !== response_filter_data_reference_favorite[0].name){

                    const response_filter_favorite_by_alias = dataFavoritesReference.filter( (row) => row.name === alias.toUpperCase())

                    if(response_filter_favorite_by_alias.length > 0){
                        flag_validation_repeat_favorite = true
                    }else{
                        flag_validation_repeat_favorite = false
                    }

                }else{
                    flag_validation_repeat_favorite = false
                }

                if(flag_validation_repeat_favorite === false){

                        if(reference !== response_filter_data_reference_favorite[0].reference){

                            const response_filter_favorite_by_reference = dataFavoritesReference.filter( (row) => row.reference === reference)

                            if(response_filter_favorite_by_reference.length > 0){
                                flag_validation_repeat_favorite = true
                            }else{
                                flag_validation_repeat_favorite = false
                            }
                        }else{
                            flag_validation_repeat_favorite = false
                        }

                        if(flag_validation_repeat_favorite === false){

                            const sendData = encrypt(JSON.stringify({
                                action : "UPDATE",
                                dataFavoriteReference : {
                                    id : initialValuesFormEditFavorites.id,
                                    name : alias.toUpperCase(), 
                                    reference, 
                                    agreement : response_filter_agreement[0].identity, 
                                    institution : agreement.name
                                }
                            }))
                            await feathersCreateData("procces-favorite-reference", { sendData })()
                            handleGetReferenceFavorites()
                            setOpenDialog(false)
                            handleOpenSnack("Se ha actualizado correctamente.", "success")
                            setLoading(false)
                        }else{
                            setLoading(false)
                            handleOpenSnack("La referencia ya existen.", "info")
                        }
                }else{
                    setLoading(false)
                    handleOpenSnack("El alias ya existen.", "info")
                }

            }else{
                setLoading(false)
                handleOpenSnack("No se ha encontrado el convenio seleccionado.", "info")
            }

        } catch (error) {
            //console.log(error)
            handleOpenSnack("Ha ocurrido un error al actualizar la referencia favorita.", "error")
            setLoading(false)

        }

    }

    const handleCancelFormEditFavorites = () => {
        setDialogTitle("Lista de Favoritos")
        setDialogContent(renderListReferenceFavorites())
    }

    const handleSelectedReferenceFavorites = (row) => {
        //console.log(row)

        try {

            const { reference, agreement, name } = row
            
            const response_get_agreement = agreementsSwitchServices.filter( (item) => item.identity === agreement )

            if(response_get_agreement.length > 0){

                const response_filter_agreements_rate = otherServices.filter( (valueItem) => valueItem.Nombre === response_get_agreement[0].nameIdentity)

                if(response_filter_agreements_rate.length > 0){

                    setIsSelectedFavorite(true)
                    setOpenDialog(false)
                    setShowDetailPayment(false)
                    setIsSelectedOptionMenu(false)

                    setAgreementRateSelected(response_filter_agreements_rate[0])
                    
                    setAgreementsSelected(response_get_agreement[0])
        
                    let auxdata = dataElectronicRecharges;
        
                    auxdata.cellphone = reference;
                    auxdata.alias = name;
        
                    //console.log(auxdata)
        
                    setDataElectronicRecharges(auxdata)
        
                    //console.log(dataElectronicRecharges)

                }else{

                    handleOpenSnack("No se ha encontrado el convenio para realizar la recarga.", "info");
                    setAgreementsSelected({
                        AgreementForm : [],
                        category : "",
                        hasIndividualRate : 1,
                        name : "",
                        rate : "0",
                        uuid : "",
                        identity : "",
                        nameIdentity : ""
                    })

                }
            
            }else{
                handleOpenSnack("No se ah encontrado el convenio al que pertenece la referencia seleccionada. Por favor elimine la referencia y vuelva a registrarla.", "info")
            }

        } catch (error) {
            handleOpenSnack("Ha ocurrido un error al seleccionar la referencia.", "error")
        }
    }

    const handleCloseDialog = (value) => {
        setOpenDialog(false)
    }

    const handleCloseDialogAddFavorites = () => {
        setOpenDialogAddFavorites(false)
    }

    const saveFavorites = () => {
        
        setLoading(true)

        try {

            const response_filter_favorites_references = dataFavoritesReference.filter( (item) => item.reference === dataElectronicRecharges.cellphone)

            if(response_filter_favorites_references.length > 0){

                setLoading(false)
                handleOpenSnack('La referencia ya se encuentra agregada.', 'info')

            }else{

                setLoading(false)
                //setIsFavorites(false)
                setOpenDialogAddFavorites(true)

            }

        } catch (error) {
            
            //console.log(error)
            setLoading(false)
            handleOpenSnack('No se ha podido generar el código. Por favor intente nuevamente.', 'error')

        }
    }

    const handleSubmitAddFavorites = async(values) => {
        //console.log(values)

        try {
            
            setLoading(true)

            const { alias } = values;

            setDataElectronicRecharges({
                ...dataElectronicRecharges,
                alias
            })

            const response_filter_favorites_references_alias = dataFavoritesReference.filter( (item) => item.name === alias.toUpperCase())

            if(response_filter_favorites_references_alias.length > 0){

                setLoading(false)
                handleOpenSnack('El alias ya se encuentra agregado.', 'info')

            }else{

                setOpenDialogAddFavorites(false)

                const sendData = encrypt(JSON.stringify({
                    action : "CREATE",
                    dataFavoriteReference : {
                        reference : dataElectronicRecharges.cellphone,
                        name : alias.toUpperCase(),
                        agreement : agreementsSelected.identity,
                        institution : agreementsSelected.name,
                        additionalInformation : "",
                        categoryAgreement : "RECARGAS",
                        state : 1,
                        user : auth.id
                    }
                }))
                
                await feathersCreateData("procces-favorite-reference", {
                    sendData
                })()

                setIsFavorites(true)

                //console.log(response_save_favorites_reference)

                let auxDataFavoritesReference = dataFavoritesReference

                auxDataFavoritesReference.push({
                    reference : dataElectronicRecharges.cellphone,
                    name : alias.toUpperCase(),
                    agreement : agreementsSelected.identity,
                    institution : agreementsSelected.name,
                    additionalInformation : "",
                    categoryAgreement : "RECARGAS",
                    state : 1,
                    user : auth.id
                })

                setDataFavoritesReference(auxDataFavoritesReference)

                handleOpenSnack('Se ha almacenado exitosamente a favoritos.', 'success')

                setLoading(false)

            }

        } catch (error) {
            
            setLoading(false)
            handleOpenSnack('No se ha podido registrar a favoritos. Por favor intente nuevamente.', 'error')

        }
    }

    const renderProcess = () => {
        return (showDetailPayment === false) ? <ElectronicRechargesFormReduxForm 
                                                    onSubmit = { handleSubmit }
                                                    agreementsSelected = { agreementsSelected }
                                                    setAgreementsSelected = { handleChangeAgreement }
                                                    agreements = { agreementsSwitchServices }
                                                    cellphone = { dataElectronicRecharges.cellphone }
                                                    isActionFavorite = { isSelectedFavorite }
                                                    onCancelAction = { onCancelAction }
                                                /> : <ElectronicRechargesInfoPanel 
                                                        listDetail = { listDetail }
                                                        processPayment = { handleSubmitPayment }
                                                        getBack = { onChangeAgremeement }
                                                        isFavorites = { isFavorites }
                                                        saveFavorites = { saveFavorites }
                                                    />
    }

    const renderVoucher = () => {

        return <Voucher 
                    amount = { parseFloat(dataVoucher.MontoPagar).toFixed(2) }
                    titleheader = { "Valor cancelado" }
                    title = { "Comprobante" }
                    textButtonCancel = { "Nuevo Pago" }
                    handleCancel = { onCancelAction }
                    databodyone = {
                                    [
                                        {
                                            title : "Servicio:",
                                            value : dataVoucher.Servicio,
                                            order : 1
                                        },
                                        {
                                            title : "Institución:",
                                            value : dataVoucher.NombreInstitucion,
                                            order : 2
                                        },
                                        {
                                            title : "Referencia:",
                                            value : dataVoucher.NumeroDeReferencia,
                                            order : 3
                                        },
                                        {
                                            title : "Socio:",
                                            value : user.NumeroCliente,
                                            order : 4
                                        },
                                        {
                                            title : "Cliente:",
                                            value : dataVoucher.NombreCliente,
                                            order : 5
                                        },
                                        {
                                            title : "Número de Cuenta:",
                                            value : dataVoucher.NroDeCuenta,
                                            order : 6
                                        },
                                        {
                                            title : "Comisión:",
                                            value : "$ "+parseFloat(dataVoucher.Comision).toFixed(2),
                                            order : 7
                                        },
                                        {
                                            title : "Fecha:",
                                            value : moment(dataVoucher.FechaPago).format("YYYY/MM/DD"),
                                            order : 8
                                        },
                                        {
                                            title : "Concepto:",
                                            value : dataVoucher.Concepto,
                                            order : 9
                                        },
                                        {
                                            title : "No. de transacción:",
                                            value : dataVoucher.DocumentoTransaccion,
                                            order : 10
                                        }
                                    ]
                                }
                    handleDownloadVoucher = { handleDownloadVoucher }
                    handleDownloadDevice = { () => {
                        try {
                            feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataVoucher.DocumentoTransaccion, name_voucher: dataVoucher.name_voucher})().then(res => {
                                if (res.error) {
                                    handleOpenSnack(res.message, 'error')
                                } else {
                                    let send = {
                                        type: 'action',
                                        action: 'export_voucher',
                                        data: urlVoucher+res.voucher+".pdf",
                                        nameFile: res.voucher,
                                        extension: 'pdf',
                                        messageSend: 'Recarga Electronica'
                                    }
                                    sendMobile(JSON.stringify(send))
                                }
                            }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                        } catch (error) {
                            //console.log(error)
                        }
                    }}
                />

    }

    const handleSelectedItemMenu = (option) => {
        //console.log(option)

        try {
            
            const { id } = option;

            if(id === "2"){
                setIsSelectedOptionMenu(false)
                setIsSelectedFavorite(false)
            }else{
                setOpenDialog(true)
                setDialogTitle("Lista de Favoritos")
                setDialogContent(renderListReferenceFavorites())
            }

        } catch (error) {
            
        }
    }   

    const renderMenu = () => {

        return <StandardList 
                    dataList={ dataList }
                    primary={'primary'}
                    secondary = { 'secondary'}
                    selectItem = { handleSelectedItemMenu }
                />
    }

    const renderBody = () => {
        const {openOtp} = OTP
        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return  <UserPanelInfoMobile 
                            user = { user }
                            balances = { balances } 
                            accountSelected = { accountSelected }
                            changeAccount = { setAccountSelected }
                            handleAccountChange = { handleAccountChange }
                            dialog = { showDialogAccounts }
                        >
                            { (isSelectedOptionMenu === true) ? renderMenu() : (showVoucher === false) ? renderProcess() : renderVoucher()}
                            <DialogOTP
                                openDialogOTP= { openOtp }
                                onCloseDialogOTP = { () => setOTP({...OTP, openOtp: false})}
                                initialTime = { Date.now()}
                                loading = {loading}
                                showQR = {false}
                                OTPSubmit = { handleOTPCompare }
                                onKeyPress = { handleChangeInputOtp }
                            />
                        </UserPanelInfoMobile>
            }

        }else{
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return  <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6} xl={6}>
                                <UserPanelInfo
                                    user = { user }
                                    balances = { balances } 
                                    accountSelected = { accountSelected }
                                    changeAccount = { setAccountSelected } 
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6} xl={6}>
                                { (isSelectedOptionMenu === true) ? renderMenu() : (showVoucher === false) ? renderProcess() : renderVoucher()}
                            </Grid>
                            <DialogOTP
                                openDialogOTP= { openOtp }
                                onCloseDialogOTP = { () => setOTP({...OTP, openOtp: false})}
                                initialTime = { Date.now()}
                                loading = {loading}
                                showQR = {false}
                                OTPSubmit = { handleOTPCompare }
                                onKeyPress = { handleChangeInputOtp }
                            />
                        </Grid>
    
            }
        }
    }

    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                multiple = { false }
            />
            <StandardDialog
                open = {openDialog}
                title = {dialogTitle}
                handleClose = { handleCloseDialog } >
                    {dialogContent}
            </StandardDialog>
            {
                (openDialogAddFavorites === true) && <FormSaveAliasReferenceDialogReduxForm
                                                        isOpenDialog = { openDialogAddFavorites }
                                                        onCloseDialog = { handleCloseDialogAddFavorites }
                                                        titleDialog = { "Añadir a favoritos." }
                                                        onSubmit = { handleSubmitAddFavorites }
                                                        labelField = { "Nombre de la referencia" }
                                                        placeholderField = { "Ejemplo: Iphone 7" } 
                                                        nameButtonActionSave = { "Guardar" }
                                                        nameButtonActionCancel = { "Cancelar" }
                                                    />
            }
            <LoadingScreen open={loading} />
        </div>
    )
}

export default connect(null, {
    createProcessMeterCode,
    sendEmailWithVoucher,
    changeStatusUser,
    getBalanceUser,
    getAgreementsSwitchServices
} )(ElectronicRechargesContainer)
